<template>
	<div class="alert-wrap" @click.self="hideAlert">
		<div class="alert-box">
			<slot name="title"></slot>
			<!--<p class="title" slot="title"></p>-->
			<slot name="content">
				
			</slot>
			<p class="btn" @click="hideAlert">好的，知道了</p>
		</div>
	</div>
</template>

<script>
	export default{
		name:"common-alert",
		data(){
			return{
				
			}
		},
		methods:{
			hideAlert(){
				this.$emit("hideAlert")
			}
		}
	}
</script>

<style scoped>
	.alert-wrap{
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.3);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9;
	}
	.alert-box{
		background: #fff;
		width: 80vw;
		border-radius: 1rem;
	}
	.alert-box .title{
		text-align: center;
		font-size: 1.1rem;
		color: #282828;
		padding: 1rem 0 0;
	}
	.alert-box .content{
		padding: 1rem;
		line-height: 1.5rem;
		font-size: 0.8rem;
	}
	.alert-box .btn{
		padding: 1rem 0;
		font-size: 1rem;
		text-align: center;
		color: #282828;
		border-top: 1px solid #F3F3F3;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/CommonAlert.vue